import store from '../store';

export const empty = {
    render(c) {
        return c('router-view');
    },
};

export function authenticated(to, from, next) {
    if (store.state.user.token) {
        next();
    } else {
        next({ name: 'signin' });
    }
}

export function is_staff(to, from, next) {
    if (store.state.user.user.is_staff) {
        next();
    } else {
        next({ name: 'spaces' });
    }
}


export default function get_query_list(query) {
    const items = query || [];
    return Array.isArray(items) ? items : [items];
}
